// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/1a9c8c328725e8f56d06.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"91c3c401971a1316177b","165":"fe5b71043e4a6b7186f4","166":"8ea29dee2be9e6ad4fc3"}[chunkId] + ".chunk.js";
};